import { type BaseQueryFn, createApi } from '@reduxjs/toolkit/query/react'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { createAxiosInstance } from '../../api'
import { GrantUserData } from '../../types'

export const apiGrantUserBaseQuery =
  (): BaseQueryFn<
    {
      url: string
      method: AxiosRequestConfig['method']
      data?: AxiosRequestConfig['data']
      params?: AxiosRequestConfig['params']
      headers?: AxiosRequestConfig['headers']
    },
    unknown,
    unknown
  > =>
  async ({ url, method, data, params, headers }) => {
    const api = createAxiosInstance(`${String(process.env.REACT_APP_ENGINE_API_URL)}/reporting/grant-users`)

    try {
      const result = await api(url, {
        method,
        data,
        params,
      })
      return { data: result.data }
    } catch (axiosError) {
      const err = axiosError as AxiosError
      console.error(err)

      throw axiosError
    }
  }

export const grantUserApi = createApi({
  reducerPath: 'grantUserApi',
  baseQuery: apiGrantUserBaseQuery(),
  endpoints: (builder) => ({
    updateGrantUser: builder.mutation<GrantUserData, { data: GrantUserData; grantUserId: string }>({
      query({ data, grantUserId }) {
        return {
          url: `/${grantUserId}`,
          method: 'put',
          data,
        }
      },
    }),
    deleteGrantUser: builder.mutation<void, { grantUserId: string }>({
      query({ grantUserId }) {
        return {
          url: `/${grantUserId}`,
          method: 'delete',
        }
      },
    }),
  }),
})

export const { useUpdateGrantUserMutation, useDeleteGrantUserMutation } = grantUserApi
